import React from 'react';
import { IoClose } from 'react-icons/io5';

const ActiveFilters = ({ filters, onRemoveFilter, onRemoveAll }) => {
  const hasActiveFilters = 
    filters.category.length > 0 || 
    filters.dateRange.pickup || 
    filters.dateRange.dropoff ||
    filters.passengers ||
    filters.transmission ||
    (filters.priceRange[0] !== 20 || filters.priceRange[1] !== 390);  // Add price range check

  if (!hasActiveFilters) return null;
  const hideFilters = filters.category.length === 1 && filters.category[0] === 'Jeep Wrangler';
  if (hideFilters && 
      !filters.dateRange.pickup && 
      !filters.dateRange.dropoff && 
      !filters.passengers && 
      !filters.transmission && 
      filters.priceRange[0] === 20 && 
      filters.priceRange[1] === 390) return null;

  return (
    <div className="mb-6">
      <div className="flex flex-wrap gap-2 mb-4">
        {filters.dateRange.pickup && filters.dateRange.dropoff && (
          <div className="flex items-center bg-gray-100 shadow-xl rounded-full px-4 py-2">
            <span className="text-sm">
              Pickup: {new Date(filters.dateRange.pickup).toLocaleDateString()} - {new Date(filters.dateRange.dropoff).toLocaleDateString()}
            </span>
            <button
              onClick={() => onRemoveFilter('dateRange')}
              className="ml-2 text-gray-500 hover:text-red-500"
            >
              <IoClose />
            </button>
          </div>
        )}
        
        {filters.category.map(cat => (
          <div key={cat} className="flex items-center bg-gray-100 shadow-xl rounded-full px-4 py-2">
            <span className="text-sm">Category: {cat}</span>
            <button
              onClick={() => onRemoveFilter('category', cat)}
              className="ml-2 text-gray-500 hover:text-red-500"
            >
              <IoClose />
            </button>
          </div>
        ))}

        {filters.passengers && (
          <div className="flex items-center bg-gray-100 shadow-xl rounded-full px-4 py-2">
            <span className="text-sm">Passengers: {filters.passengers}</span>
            <button
              onClick={() => onRemoveFilter('passengers')}
              className="ml-2 text-gray-500 hover:text-red-500"
            >
              <IoClose />
            </button>
          </div>
        )}

        {filters.transmission && (
          <div className="flex items-center bg-gray-100 shadow-xl rounded-full px-4 py-2">
            <span className="text-sm">Transmission: {filters.transmission}</span>
            <button
              onClick={() => onRemoveFilter('transmission')}
              className="ml-2 text-gray-500 hover:text-red-500"
            >
              <IoClose />
            </button>
          </div>
        )}

        {(filters.priceRange[0] !== 20 || filters.priceRange[1] !== 390) && (
          <div className="flex items-center bg-gray-100 shadow-xl rounded-full px-4 py-2">
            <span className="text-sm">Price: €{filters.priceRange[0]} - €{filters.priceRange[1]}</span>
            <button
              onClick={() => onRemoveFilter('priceRange')}
              className="ml-2 text-gray-500 hover:text-red-500"
            >
              <IoClose />
            </button>
          </div>
        )}
      </div>
      
      <button
        onClick={onRemoveAll}
        className="text-red-600 hover:text-red-700 text-sm font-medium"
      >
        Remove all filters
      </button>
    </div>
  );
};

export default ActiveFilters;